import { EditPersonaModalSubmitter } from '../../lib/edit-persona-modal/edit-persona-modal-submit.service'
import { DocsEditPersonaModalSubmitter } from './docs-edit-persona-modal-submitter.service'

export const PROVIDERS = [
  {
    provide: EditPersonaModalSubmitter,
    useClass: DocsEditPersonaModalSubmitter,
  }
]
